<template>
  <div class="position-relative">
    <div
      @mouseenter="additionClass = true"
      @mouseleave="additionClass = false"
      class="buttons-transparent-layout"
      @click="$emit('go')"
      :style="cardStyles"
    ></div>
    <div
      class="card-container"
      :class="additionClass ? 'card-container--active' : ''"
    >
      <div ref="card" class="card block-gradient-small d-flex">
        <div class="card__content-wrapper" style="flex-grow: 1">
          <slot></slot>
        </div>

        <button
          v-if="showCardBtn"
          class="card-buttons-group btn card__btn"
          @click="additionClass = !additionClass"
        >
          <span class="mdi mdi-chevron-double-right"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, onMounted, ref} from "vue";
import { GSAP } from "@/plugins/gsap";

export default {
  name: "CardLayout",
  props: {
    animationDelay: { type: Number, default: 0 },
    showCardBtn: { type: Boolean, default: true },
  },
  emits: ["go"],
  setup(props) {
    const card = ref(null);
    onMounted(() => {
      GSAP.fromTo(
        card.value,
        {
          opacity: 0,
          x: -100,
          scale: 0.5,
        },
        {
          // scrollTrigger: card.value,
          delay: props.animationDelay * 0.15,
          x: 0,
          opacity: 1,
          duration: 1,
          scale: 1,
          ease: "back.inOut",
        }
      );
    });
    return {
      card,
      additionClass: ref(false),
      cardStyles: computed(() => ({
        'pointer-events': props.showCardBtn ? 'auto' : 'none',
      })),
    };
  },
};
</script>

<style scoped lang="scss">
.card-buttons-group {
  position: absolute;
  height: 100%;
  right: 0;
  top: 0;
}

.buttons-transparent-layout {
  position: absolute;
  top: 0;
  right: 0;
  width: 30%;
  height: 100%;
  z-index: 1;
  cursor: pointer;
}

.card-container {
  cursor: auto;
  transition: all 1s ease-in-out;
  height: 100%;
  position: relative;

  &--100pc {
  }

  &--active {
    transform: perspective(1000px) rotateY(10deg);

    .card__btn {
      transform: translateX(10px);
      color: var(--color-white);
    }
  }
}

.card__btn:hover {
  transform: translateX(50%);
  color: var(--color-white);
}

.card {
  height: 100%;

  &__content-wrapper {
    width: 100%;
  }

  &__btn {
    font-size: xxx-large;
    color: var(--color-blue-light);

    * {
      transition: var(--pat-transition-main);
    }
  }
}
</style>
